<template>
  <tr>
    <td class="vertical-top position-relative absolute-bottom--wrapper td-with-action">
      <h4>{{ hospital.title }}</h4>
      <div class="absolute-bottom d-flex">
        <router-link
          :to="{ name: 'hospital-edit', params: { id: hospital.id } }"
          class="btn btn-primary btn-with-icon"
        >
          <span class="icon icon-edit"></span>{{ $t('button.edit') }}</router-link
        >
        <button
          v-if="hospital.can_remove"
          type="button"
          class="btn btn-danger btn-with-icon ml-2"
          @click="deleteHospital()"
        >
          <span class="icon icon-minus"></span>{{ $t('button.delete') }}
        </button>
      </div>
    </td>
    <td>
      <hospital-admins :hospital-id="hospital.id"></hospital-admins>
    </td>
    <td class="subscription">
      <subscription-info
        :dateSubscription="this.hospital.date_subscription_end"
        :isShort="true"
      ></subscription-info>
    </td>
    <td class="vertical-top td-menu">
      <router-link
        :to="{ path: '/courses', query: { hospital: hospital.id } }"
        class="btn btn-link btn-block mb-1 text-left"
      >
        <span class="icon icon-courses"></span
        >{{ $t('src/components/table-rows/hospitaltablerow.1305') }}</router-link
      >
      <router-link
        :to="{ path: '/sessions', query: { hospital: hospital.id } }"
        class="btn btn-link btn-block mb-1 text-left"
      >
        <span class="icon icon-sessions"></span>{{ $t('entity.sessions') }}</router-link
      >
      <router-link
        :to="{ path: '/users', query: { hospital: hospital.id } }"
        class="btn btn-link btn-block mb-1 text-left"
      >
        <span class="icon icon-users"></span
        >{{ $t('src/components/table-rows/hospitaltablerow.3354') }}</router-link
      >
      <router-link
        :to="{ path: '/devices', query: { hospital: hospital.id } }"
        class="btn btn-link btn-block mb-1 text-left"
      >
        <span class="icon icon-devices"></span>{{ $t('entity.devices') }}</router-link
      >
    </td>
  </tr>
</template>

<script>
import declension from '@/modules/declension.js'

export default {
  name: 'HospitalTable',
  components: {
    HospitalAdmins: () => import('@/components/HospitalAdmins.vue'),
    SubscriptionInfo: () => import('@/components/SubscriptionInfo.vue')
  },
  props: {
    hospital: {
      type: Object,
      required: true
    }
  },
  computed: {
    isSubscriptionEnds() {
      if (this.hospital.date_subscription_end) return true
      else return false
    },
    subscriptionEndsStr() {
      if (this.hospital.date_subscription_end) {
        let momentDate = this.moment(this.hospital.date_subscription_end)
        if (momentDate.isSameOrBefore(this.nowMoment, 'day')) {
          return this.$t('general.expired')
        } else {
          let diffDate = momentDate.diff(this.nowMoment, 'days')
          if (diffDate < 14) {
            return `${this.$t('general.willExpired')} ${diffDate} ${declension(diffDate, [
              `${this.$tc('unit.day', 0)}`,
              `${this.$tc('unit.day', 1)}`,
              `${this.$tc('unit.day', 2)}`
            ])}`
          } else return ''
        }
      } else {
        return ''
      }
    }
  },
  methods: {
    deleteHospital() {
      let ok = confirm(
        `${this.$t('src/components/table-rows/hospitaltablerow.confirmDeleteHospital')} "${
          this.hospital.title
        }"?`
      )
      if (!ok) {
        return
      }

      this.$emit('delete', this.hospital.id)
    }
  }
}
</script>
